/**
 * Enova Quick Add to Cart - Opens Dawn Cart Drawer
 * Works with product cards that have .card__add-btn buttons
 */

(function() {
  'use strict';

  /**
   * Actualiza y abre el cart drawer de Dawn usando su método nativo
   */
  async function openDawnCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.log('[Enova] Dawn cart-drawer element not found');
      return;
    }

    try {
      // Usar el método nativo de Dawn para obtener y renderizar las secciones
      const sections = 'cart-drawer,cart-icon-bubble';
      const response = await fetch(`${window.Shopify.routes.root}?sections=${sections}`, {
        credentials: 'same-origin'
      });
      const sectionsData = await response.json();
      
      console.log('[Enova] Sections fetched, cart-drawer received');

      // Usar renderContents si está disponible (método nativo de Dawn)
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({ sections: sectionsData });
        console.log('[Enova] Dawn cart drawer rendered via native method');
      } else {
        // Fallback manual
        updateCartDrawerManually(sectionsData);
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        console.log('[Enova] Dawn cart drawer updated manually');
      }

      // IMPORTANTE: Remover clase is-empty inmediatamente
      removeEmptyClass();
      
      // También remover después de un pequeño delay (por si renderContents la re-agrega)
      setTimeout(removeEmptyClass, 50);
      setTimeout(removeEmptyClass, 150);

    } catch (error) {
      console.error('[Enova] Error updating Dawn cart drawer:', error);
      // Fallback: solo abrir
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }
  }

  /**
   * Remueve la clase is-empty de todos los elementos del cart drawer
   */
  function removeEmptyClass() {
    // Remover de cart-drawer (elemento principal)
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
    }
    
    // Remover de .drawer (si es diferente)
    document.querySelectorAll('.drawer.is-empty').forEach(el => {
      el.classList.remove('is-empty');
    });
    
    // Remover de .drawer__inner
    document.querySelectorAll('.drawer__inner.is-empty').forEach(el => {
      el.classList.remove('is-empty');
    });

    // Remover de cart-drawer-items
    document.querySelectorAll('cart-drawer-items.is-empty').forEach(el => {
      el.classList.remove('is-empty');
    });
    
    // Remover de cart-items
    document.querySelectorAll('cart-items.is-empty').forEach(el => {
      el.classList.remove('is-empty');
    });

    // Remover de cualquier otro elemento dentro del drawer
    if (cartDrawer) {
      cartDrawer.querySelectorAll('.is-empty').forEach(el => {
        el.classList.remove('is-empty');
      });
    }

    console.log('[Enova] Removed is-empty class from all cart elements');
  }

  /**
   * Actualización manual del cart drawer como fallback
   */
  function updateCartDrawerManually(sectionsData) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // Actualizar CartDrawer
    if (sectionsData['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
      const newDrawer = doc.getElementById('CartDrawer');
      const currentDrawer = document.getElementById('CartDrawer');
      
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    }

    // Actualizar icono del carrito
    if (sectionsData['cart-icon-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
      const newIcon = doc.querySelector('.shopify-section');
      const currentIcon = document.getElementById('cart-icon-bubble');
      
      if (newIcon && currentIcon) {
        const container = currentIcon.closest('.shopify-section');
        if (container) {
          container.innerHTML = newIcon.innerHTML;
        }
      }
    }

    // Remover clase is-empty
    cartDrawer.classList.remove('is-empty');
    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.classList.remove('is-empty');
    }
  }

  /**
   * Manejador para clics en botones de agregar al carrito
   */
  function handleAddToCartClick(event) {
    const addButton = event.target.closest('.card__add-btn');
    if (!addButton) return;

    const variantId = addButton.getAttribute('data-id');
    const comparePrice = addButton.getAttribute('data-compared');

    // Verificar que hay un variant ID válido
    if (!variantId || variantId === '' || variantId === 'null' || variantId === 'undefined') {
      console.log('[Enova] No valid variant ID, ignoring');
      return;
    }

    // Prevenir comportamiento por defecto
    event.preventDefault();
    event.stopPropagation();

    console.log('[Enova] Adding to cart:', { variantId, comparePrice });

    // Mostrar loading en el botón
    addButton.style.opacity = '0.5';
    addButton.style.pointerEvents = 'none';

    // Preparar datos
    const formData = {
      items: [{
        id: parseInt(variantId),
        quantity: 1,
        properties: {}
      }]
    };

    // Agregar compare price si existe
    if (comparePrice) {
      formData.items[0].properties._comparedAtPrice = comparePrice;
    }

    // Hacer el fetch para agregar al carrito
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Error adding to cart');
      }
      return response.json();
    })
    .then(async data => {
      console.log('[Enova] Product added successfully:', data);
      
      // Actualizar $Cart si existe (para mantener sincronizado el sistema Vue)
      if (window.$Cart && typeof window.$Cart.get === 'function') {
        window.$Cart.get();
      }

      // Esperar un momento para que el servidor procese el carrito
      await new Promise(resolve => setTimeout(resolve, 500));

      // Abrir el cart drawer de Dawn
      return openDawnCartDrawer();
    })
    .catch(error => {
      console.error('[Enova] Error adding to cart:', error);
      alert('Error adding product to cart. Please try again.');
    })
    .finally(() => {
      // Restaurar botón
      addButton.style.opacity = '';
      addButton.style.pointerEvents = '';
    });
  }

  /**
   * Desactivar el handler original del tema para .card__add-btn
   */
  function disableOriginalHandler() {
    // Capturar el evento antes que el tema
    document.addEventListener('click', handleAddToCartClick, true);
    console.log('[Enova] Custom add to cart handler registered');
  }

  /**
   * También manejar cuando $Cart.toggleDrawer se llama directamente
   */
  function overrideToggleDrawer() {
    const checkCart = setInterval(() => {
      if (window.$Cart && window.$Cart.toggleDrawer) {
        clearInterval(checkCart);
        
        const originalToggleDrawer = window.$Cart.toggleDrawer.bind(window.$Cart);
        
        window.$Cart.toggleDrawer = function(open = null) {
          if (open === true) {
            openDawnCartDrawer();
          } else if (open === false) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.close === 'function') {
              cartDrawer.close();
            }
          } else {
            // Toggle
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              if (cartDrawer.classList.contains('active')) {
                cartDrawer.close();
              } else {
                openDawnCartDrawer();
              }
            }
          }
        };
        
        console.log('[Enova] $Cart.toggleDrawer overridden');
      }
    }, 100);

    setTimeout(() => clearInterval(checkCart), 5000);
  }

  // Inicializar
  function init() {
    disableOriginalHandler();
    overrideToggleDrawer();
    console.log('[Enova] Dawn cart drawer integration initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

